import React from 'react';
import PropTypes from 'prop-types';

import UploadBox from 'components/UploadBox';

import UploadWorkSubtitle from './UploadWorkSubtitle';

const UploadWorkMedia = (props) => (
    <div className="upload-work__media">
        <div className="form-group">
            <UploadBox
                accept={props.accept}
                multiple={false}
                filesAreBeingUploaded={props.filesAreBeingUploaded}
                onDrop={props.onDrop}
            />
        </div>

        <UploadWorkSubtitle withSubtitle={props.withSubtitle} />
    </div>
);

UploadWorkMedia.propTypes = {
    accept: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    filesAreBeingUploaded: PropTypes.bool,
    withSubtitle: PropTypes.bool,
    onDrop: PropTypes.func.isRequired,
};

UploadWorkMedia.defaultProps = {
    accept: undefined,
    filesAreBeingUploaded: false,
    withSubtitle: true,
};

export default UploadWorkMedia;



// WEBPACK FOOTER //
// ./src/components/arena/UploadWorkMedia.js